import { render, staticRenderFns } from "./RuleEditModal.vue?vue&type=template&id=bc16e0b8"
import script from "./RuleEditModal.vue?vue&type=script&lang=js"
export * from "./RuleEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports